module.exports = __webpack_public_path__ + "img/17_83.ee337740.png";